import * as React from "react";

import { DropdownContext } from "./DropdownProvider";

export const DropdownMenuContainer = (props: React.PropsWithChildren<any>) => {
    const { children } = props;
    const { classes, menuProps, isOpen } = React.useContext(DropdownContext);

    return (
        <div className={classes?.menu} {...menuProps}>
            {isOpen ? (
                <div className={classes?.menuContainer}>
                    {children}
                </div>
            ) : null}
        </div>
    );
};
